import React, { useEffect, useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useUpdateAccountName } from "@/features/accounts/shared/hooks/use-update-account-name";
import { useInstitutionsServices } from "@/features/institutions/hooks/use-institutions-services";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { CsvBankCodeList } from "@/shared/config/globals";
import { useInputValidation } from "@/shared/hooks/use-input-validation";

interface Props {
  accountGroupId: string;
  mlinkAccountId: string;
  mlinkId: string;
  passbookType: string;
  passbookName: string;
  onTapCloseModal: () => void;
  onTapCompleteModal: (newName: string) => void;
}

// 口座名変更モーダル
export const UpdateAccountNameModal= ({
  accountGroupId,
  mlinkAccountId,
  mlinkId,
  passbookType,
  passbookName,
  onTapCloseModal,
  onTapCompleteModal,
}: Props) => {
  const {
    authType,
  } = useInstitutionsContext();
    const {
    getInstitutionsServices,
  } = useInstitutionsServices();
  const {
    selectedAccount
  } = useAccountGroupsContext();
  const { validate } = useInputValidation("deleteOver4Bytes");
  const { updateAccountName } = useUpdateAccountName({onTapCompleteModal});
  const [newName, setNewName] = useState(validate(passbookName));
  const [isActiveUpdateButton, setIsActiveUpdateButton] = useState(false);
  const [showInstitutionInfo, setShowInstitutionInfo] = useState(false);
  const [showCsvInfo, setShowCsvInfo] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [serviceName, setServiceName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedAccount) return;
      const passbookType = selectedAccount.passbookType;
      if ( passbookType === "01"
        || passbookType === "19659"
        || passbookType === "19660"
        || passbookType === "03"
        || passbookType === "10"
        || passbookType === "20"
      ) {
        setShowInstitutionInfo(true);
        const resService = await getInstitutionsServices(
          selectedAccount.industryCode || "",
          selectedAccount.companyCode || "",
          selectedAccount.branchCode || "",
        );

        // resからcodeに合致するものを見つけて、serviceNameを取得する
        const companyName = resService?.find(company => company.companyCode === selectedAccount.companyCode)?.companyName || "";
        const serviceName = resService?.find(service => service.serviceCode === selectedAccount.serviceCode)?.serviceName || "";
        const branchName = resService?.find(branch => branch.branchCode === selectedAccount.branchCode)?.branchName || "";
        const institutionName = companyName + (branchName !== "" ? " " + branchName : "");

        setCompanyName(institutionName);
        setServiceName(serviceName);
      }
      else if (passbookType === "201") {
        setShowCsvInfo(true);
        setCompanyName(CsvBankCodeList.filter(list => list.value === selectedAccount.companyCode)[0]?.label || "");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setIsActiveUpdateButton(newName !== "");
  }, [newName]);

  const onChangeName = (value: string) => {
    setNewName(value.trim());
  };

  // 変更ボタンに付与するID
  const updateAccountNameButton = "update_account_name_button";

  return (
    <BasePageModal
      title="Web明細帳名の変更"
      className="md-list-edit edit-account-name-modal"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="Web明細帳名を変更"
          isActive={isActiveUpdateButton}
          onClick={() => updateAccountName(
            accountGroupId,
            mlinkAccountId,
            mlinkId,
            passbookType,
            newName.slice(0, 50).trim(),
          )}
          id={updateAccountNameButton}
          loadingNegative={true}
        />
      }
      disableOverlayClose={true}
    >
      <h2>現在のWeb明細帳名を変更できます</h2>
      <>
        {showInstitutionInfo && (
          <dl>
            <SimpleForm
              id="companyName"
              value={companyName}
              isReadOnly={true}
              title="金融機関"
              onChange={() => {}}
              labelEnable={true}
              descriptionType={true}
            />
            <SimpleForm
              id="serviceName"
              value={serviceName}
              isReadOnly={true}
              title="サービス"
              onChange={() => {}}
              labelEnable={true}
              descriptionType={true}
            />
          </dl>
        )}
        {showCsvInfo && (
          <dl>
            <SimpleForm
              id="companyName"
              value={companyName}
              isReadOnly={true}
              title="金融機関"
              onChange={() => {}}
              labelEnable={true}
              descriptionType={true}
            />
          </dl>
        )}
        <dl className="account-name">
          <dt>Web明細帳名</dt>
            <SimpleForm
              title="Web明細帳名"
              initialValue={newName}
              placeholder="口座名を設定"
              onChange={(value) => {
                onChangeName(value);
              }}
              descriptionType={true}
            />
        </dl>
      </>
    </BasePageModal>
  );
};
